namespace e5.ScrollViewScale {
    class ScrollViewScaleOriginal implements IScrollViewScale {
        public getScale(view: ScrollView): number {
            return 1;
        }
    }

    export const Original = new ScrollViewScaleOriginal();
}